/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import AssetModel from 'cio/models/asset';

interface AssetLibraryListArgs {
  assets: AssetModel[];

  onCopy?: (asset: AssetModel) => unknown;
  onPreview?: (asset: AssetModel) => unknown;
  onDelete?: (asset: AssetModel) => unknown;

  onSelect: (asset: AssetModel) => unknown;
  unselectableAssetReasons?: Record<string, string>;

  onCheck?: (checked: boolean, asset: AssetModel) => unknown;
  checkedAssetIds?: string[];

  draggableOptions?: any;
  onBeforeDragStart?: (asset: AssetModel) => unknown;
  onDrop?: (asset: AssetModel) => unknown;
}

export default class AssetLibraryList extends Component<AssetLibraryListArgs> {
  tableHeaders = [
    { label: 'Name', class: 'w-5/12' },
    { label: 'Date', class: 'w-3/12' },
    { label: 'Size', class: 'w-2/12' },
  ];
}
